export const API_URL_FACTORY = {
  PUC_API: (regNo: string) => `/api/app/puc/?regNo=${regNo}`,
  VEHICLE_INFO_API: (regNo: string) => `/api/app/vehicleInfo/?regNo=${regNo}`,
  DEPP_LINK_API: (regNo: string, widgetType: string, utmLead: string, mobileNo: string, billerId?: string) =>
    `/api/app/deepLink/?regNo=${regNo}&widgetType=${widgetType}&utmLead=${utmLead}&mobileNo=${mobileNo}${
      billerId ? `&billerId=${billerId}` : ''
    }`,
  PUC_FETCH: (pucService: string, regNo: string | null) => `${pucService}/vas/api/v1/pucs?registration-number=${regNo}`,
  PROPOSAL_FETCH: (regNo: string, mobileNo: string) =>
    `/api/app/motor-proposal/?registration_number=${regNo}&phone=${mobileNo}`,
  VIEW_CHALLAN_ENDPOINT: (regNo: string) => `/api/app/challan/?regNo=${regNo}`,
  SAVINGS_ACCOUNT_BALANCE: (userId: string) => `/rewards/api/v1/savings-account?user_id=${userId}`,
  VEHICLE_IMAGE_API: userId => `/api/app/vehicleImage/?user_id=${userId}`,
  VIEW_ULIP_ENDPOINT_WRAPPER: (regNo: string) => `/api/app/challan/?regNo=${regNo}&source=ulip`,
  VIEW_ULIP_ENDPOINT: (regNo: string) =>
    `/vas/api/v1/challans/parivahan?use-case=latest&source=central-vas&registration-number=${regNo}`,
}
